export const SIDE_AGNOSTIC_FOCAL_TYPES = ['SINGLEVISION', 'SINGLEVISIONEXTENDED']

export const getHasSideSelection = focalType =>
  focalType != null && !SIDE_AGNOSTIC_FOCAL_TYPES.includes(focalType)

export const SIDE_OPTIONS_WITH_SELECTION = [
  { value: 'R', label: 'R' },
  { value: 'L', label: 'L' },
]

export const SIDE_OPTIONS_BOTH_ONLY = [{ value: 'B', label: 'B' }]

export const getSideOptions = hasSideSelection =>
  hasSideSelection ? SIDE_OPTIONS_WITH_SELECTION : SIDE_OPTIONS_BOTH_ONLY

export const resolveGridSide = (hasSideSelection, side) => {
  if (!hasSideSelection) return 'B'
  return side === 'L' ? 'L' : 'R'
}
